import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
})
export class SkeletonComponent implements OnInit, OnChanges {
  @Input() pageSize: number;
  @Input() titleSize: any[];
  @Input() gridLength: number;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    //counting the visibleWidth of each column and check whether the column is hidden.
    var totalVisibleWidth = 0;
    var columnToShow = this.titleSize.filter((column) => !column.hidden);
    var undefinedColumn = columnToShow.filter((column) => !column.width);
    columnToShow.forEach((column) => totalVisibleWidth += column._width ? column._width : 0);

    //get the full width of tbody of the kendo-grid (need both of tbody to have the same size or the value will be wrong.)
    let skeleton = this.gridLength;
    if(skeleton === 0) {
      skeleton = window.innerWidth;
    }
    var undefinedWidth = (skeleton - totalVisibleWidth) / undefinedColumn.length;

    //adding the width to each column
    this.titleSize = [];
    columnToShow.forEach((column) => {
      var width = column.width ? column.width + 'px': undefinedWidth.toString() + 'px';
      this.titleSize.push(width);
    });
  }
}
